import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { DropDown } from "./textField";
import { content } from "../utils/data";
import FileUploadDropzone from "./uploadFile";
import { DatePickerField, Field, YearPicker } from "./textField";
import { Autocomplete, TextField } from "@mui/material";
const steps = ["Location", "Metadata", "Upload"];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: 600,
  minHeight: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  overflow: "auto",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const UploadModal = ({
  open,
  onClose,
  responseDataClassification,
  selectedDocumentClassification,
  onChangeDocumentClassification,
  responseDataState,
  nameState,
  stateId,
  onChangeState,
  selectedStateId,
  responseDataLocation,
  nameLocation,
  locationId,
  onChangeLocation,
  selectedLocationId,
  isEditing,
  responseDataSite,
  siteId,
  responseDataCategory,
  DocumentName,
  selectedDocument,
  DocumentCategory,
  responseDataSurvey,
  responseDataUniqueNo,
  responseDataType,
  DocTypeName,
  DocType,
  PurchaseDate,
  onChangePurchaseDate,
  onChangeDescription,
  onChangeTitle,
  DocumentDescription,
  os,
  onChangeOS,
  handleSubmit,
  uploadedFiles,
  setUploadedFiles,
  responseDataTypeOs,
  OsNo,
  selectedOs,
  responseDataEntity,
  EntityNo,
  selectedEntity,
  PeriodFrom,
  PeriodTo,
  onChangeFrom,
  onChangeTo,
  DocumentTitle,
  siteName,
  selectedSiteID,
  uniqueNoId,
  setSelectedUnique,
  selectedDocumentType,
  onChangeSite,
  onChangeType,
  box,
  onChangeBox,
  entity,
  onChangeEntity,
  responseDataBuilding,
  nameBuildingCode,
  buildingId,
  onChangeBuilding,
  selectedBuildingId,
  onChangeUniqueNo,
  onChangeDocumentType,
  FileType,
  Category,
  reciptTitle,
  onChangeReciptTitle,
  khataTitle,
  onChangeKhataTitle,
  amountTitle,
  onChangeAmountTitle,
  salesDeedNo,
  onChangeSalesDeedNo,
  sellerName,
  onChangeSellerName,
  leaseDate,
  leaseNumber,
  onChangeLeaseDate,
  onChangeLeaseNumber,
  selectedSiteType,
  ReferenceDocTitle,
  ReferenceDocDescription,
  onChangeReferenceDocTitle,
  onChangeReferenceDocDescription, // ✅ ADD THESE

  grandParentDocTitle,
  grandParentDocDescription,
  onChangegrandParentDocTitle,
  onChangegrandParentDocDescription,

  parentDocTitle,
  parentDocDescription,
  onChangeParentDocTitle,
  onChangeParentDocDescription,
  propertyTax,
  cnrNumbers,
  selectedCnrNumber,
onChangeCnrNumber,

}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);


  useEffect(() => {
    if (open) {
      setActiveStep(0);
      setCompleted({});
      setIsSubmitting(false);
    }
  }, [open]);
  if (!open) return null;

  const handleNext = () => {
    const newCompleted = { ...completed, [activeStep]: true };
    setCompleted(newCompleted);
    setActiveStep((prev) => prev + 1);
  };

  const handlePrevious = () => {
    const newCompleted = { ...completed };
    delete newCompleted[activeStep - 1]; // Remove the green tick for the previous step
    setCompleted(newCompleted);
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };
  const handleFinishClick = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      await handleSubmit();

      // ✅ Reset steps and completion
      setActiveStep(0);
      setCompleted({});
      setUploadedFiles([]); // Optional: clear files after submission
      onClose(); // Optional: close modal after success
    } catch (error) {
      console.error("Submit failed", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isUniqueSurveyOptional =
    Category === "Land Documents" &&
    (FileType === "Property Tax Receipt" || FileType === "Reference Document");

  const isStepComplete = (step) => !!completed[step];

  console.log(DocType);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Upload File
        </Typography>

        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => (
            <Step key={label} completed={isStepComplete(index)}>
              <StepLabel
                StepIconComponent={({ active, completed }) =>
                  completed ? (
                    <CheckCircleIcon color="success" />
                  ) : (
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        border: "2px solid #ccc",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        backgroundColor: active ? "#1976d2" : "#fff",
                        color: active ? "#fff" : "#000",
                      }}
                    >
                      {index + 1}
                    </div>
                  )
                }
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box mt={4}>
          <Typography variant="body1" mb={2}>
            <Box mb={2}>
              {activeStep === 0 && (
                <>
                  <div className="py-3">
                    <DropDown
                      title="State*"
                      placeholder="None"
                      responseData={responseDataState}
                      labelKey={nameState}
                      valueKey={stateId}
                      onChange={onChangeState}
                      value={selectedStateId}
                      sx={{ "& .MuiTextField-root": { width: "530px" } }}
                    />
                  </div>
                  <div className="py-3">
                    <DropDown
                      title="Location*"
                      placeholder="None"
                      responseData={responseDataLocation}
                      labelKey={nameLocation}
                      valueKey={locationId}
                      onChange={onChangeLocation}
                      value={selectedLocationId}
                      sx={{ "& .MuiTextField-root": { width: "530px" } }}
                      disabled={isEditing}
                    />
                  </div>
                  <div className="py-3">
                    <DropDown
                      title="Site*"
                      placeholder="None"
                      responseData={responseDataSite}
                      labelKey={siteName}
                      valueKey={selectedSiteID}
                      value={siteId} // ✅ PASS THE ID
                      onChange={onChangeSite}
                      sx={{ "& .MuiTextField-root": { width: "530px" } }}
                    />
                  </div>

                  <div className="py-3">
                    <Field
                      type="text"
                      label="Site Type"
                      value={selectedSiteType || ""}
                      disabled={true}
                      width="530px"
                    />
                  </div>
                  <div>
                    <TextField
                      label="Property Tax"
                      value={propertyTax}
                      disabled
                      fullWidth
                      margin="normal"
                    />
                  </div>
                </>
              )}

              {activeStep === 1 && (
                <>
                  <div className="py-3">
                    <DropDown
                      title="Document Category*"
                      placeholder="None"
                      responseData={responseDataCategory}
                      labelKey={DocumentName}
                      valueKey={selectedDocument}
                      value={DocumentCategory} // ✅ PASS THE ID
                      onChange={onChangeType}
                      sx={{ "& .MuiTextField-root": { width: "530px" } }}
                    />
                  </div>

                  {Category === "Land Documents" && (
                    <>
                      <div className="py-3">
                        <DropDown
                          title="Document Type*"
                          placeholder="None"
                          responseData={responseDataType}
                          labelKey={DocTypeName}
                          valueKey={selectedDocumentType}
                          value={DocType} // ✅ PASS THE ID
                          onChange={onChangeDocumentType}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>

                      <div className="py-3">
                        <DropDown
                          title={
                            Category === "Land Documents"
                              ? "Document Classification *"
                              : "Document Classification"
                          }
                          placeholder="Select"
                          responseData={responseDataClassification}
                          labelKey="label"
                          valueKey="value"
                          value={selectedDocumentClassification}
                          onChange={onChangeDocumentClassification}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>

                      <div className="py-3">
                        <Autocomplete
                          multiple
                          id="multi-select-unique-no"
                          options={responseDataUniqueNo} // Array of options
                          getOptionLabel={(option) => option.unique_survey_no} // Label shown in the dropdown
                          value={uniqueNoId} // This should be an array of selected items
                          onChange={(event, newValue) => {
                            console.log("newValue:", newValue); // Log the new value
                            setSelectedUnique(newValue); // Update state with the new value
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label={
                                isUniqueSurveyOptional
                                  ? "Unique Survey No"
                                  : "Unique Survey No*"
                              }
                              placeholder="Select"
                            />
                          )}
                          sx={{ width: 530 }}
                        />
                      </div>

                      <div className="py-3">
                        <Field
                          label="Box*"
                          type="text"
                          value={box}
                          onChange={onChangeBox}
                          width="530px"
                        />
                      </div>

                      {FileType === "Sale Deed" && (
                        <>
                          <div className="py-3">
                            <DatePickerField
                              label="Purchase Date*"
                              value={PurchaseDate}
                              onChange={onChangePurchaseDate}
                              sx={{ width: "530px" }}
                            />
                          </div>
                          <div className="py-3">
                            <DropDown
                              title="Entity*"
                              placeholder="None"
                              responseData={responseDataEntity}
                              labelKey={EntityNo}
                              valueKey={selectedEntity}
                              value={entity} // ✅ PASS THE ID
                              onChange={onChangeEntity}
                              sx={{
                                "& .MuiTextField-root": { width: "530px" },
                              }}
                            />
                            <div className="py-3">
                              <Field
                                type="text"
                                label="Sale Deed No*"
                                value={salesDeedNo}
                                onChange={onChangeSalesDeedNo}
                                width="530px"
                              />
                            </div>
                            <div className="py-3">
                              <Field
                                type="text"
                                label="Seller Name*"
                                value={sellerName}
                                onChange={onChangeSellerName}
                                width="530px"
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {FileType === "Property Tax Receipt" ||
                      FileType === "EC" ? (
                        <div className="py-4">
                          <div className="flex gap-4 p-4 bg-gray-50 border border-gray-200 rounded-xl shadow-sm">
                            <div className="flex-1">
                              <YearPicker
                                label="Period From*"
                                selected={PeriodFrom}
                                onChange={onChangeFrom}
                              />
                            </div>

                            <div className="flex items-center text-gray-400 font-medium mt-2">
                              →
                            </div>

                            <div className="flex-1">
                              <YearPicker
                                label="Period To*"
                                selected={PeriodTo}
                                onChange={onChangeTo}
                              />
                            </div>
                          </div>
                        </div>
                      ) : null}

                      {FileType === "Property Tax Receipt" && (
                        <>
                          <div className="py-3 ">
                            <DatePickerField
                              label="Valid Until*"
                              value={PurchaseDate}
                              onChange={onChangePurchaseDate}
                              sx={{ width: "530px" }}
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Receipt Number*"
                              value={reciptTitle}
                              onChange={onChangeReciptTitle}
                              width="530px"
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Khata"
                              value={khataTitle}
                              onChange={onChangeKhataTitle}
                              width="530px"
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Amount*"
                              value={amountTitle}
                              onChange={onChangeAmountTitle}
                              width="530px"
                            />
                          </div>
                        </>
                      )}

                      {FileType === "Other Land Documents" && (
                        <>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Title*"
                              value={DocumentTitle}
                              onChange={onChangeTitle}
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Description*"
                              value={DocumentDescription}
                              onChange={onChangeDescription}
                            />
                          </div>
                        </>
                      )}
                      {FileType === "Reference Document" && (
                        <>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Title*"
                              value={ReferenceDocTitle}
                              onChange={onChangeReferenceDocTitle}
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Description*"
                              value={ReferenceDocDescription}
                              onChange={onChangeReferenceDocDescription}
                            />
                          </div>
                        </>
                      )}
                      {FileType === "Grand Parent Document" && (
                        <>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Title*"
                              value={grandParentDocTitle}
                              onChange={onChangegrandParentDocTitle}
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Description*"
                              value={grandParentDocDescription}
                              onChange={onChangegrandParentDocDescription}
                            />
                          </div>
                        </>
                      )}

                      {FileType === "Parent Document" && (
                        <>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Title*"
                              value={parentDocTitle}
                              onChange={onChangeParentDocTitle}
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Description*"
                              value={parentDocDescription}
                              onChange={onChangeParentDocDescription}
                            />
                          </div>
                        </>
                      )}

                      {FileType === "Lease Deed" && (
                        <>
                          <div className="py-3">
                            <DropDown
                              title="Entity*"
                              placeholder="None"
                              responseData={responseDataEntity}
                              labelKey={EntityNo}
                              valueKey={selectedEntity}
                              value={entity} // ✅ PASS THE ID
                              onChange={onChangeEntity}
                              sx={{
                                "& .MuiTextField-root": { width: "530px" },
                              }}
                            />
                          </div>

                          <div className="py-3">
                            <DatePickerField
                              label="Lease Date*"
                              value={leaseDate}
                              onChange={onChangeLeaseDate}
                              sx={{ width: "530px" }}
                            />
                          </div>

                          <div className="py-3">
                            <DatePickerField
                              label="Valid Until*"
                              value={PurchaseDate}
                              onChange={onChangePurchaseDate}
                              sx={{ width: "530px" }}
                            />
                          </div>

                          <div className="py-3">
                            <Field
                              type="text"
                              label="Lease Number*"
                              value={leaseNumber}
                              onChange={onChangeLeaseNumber}
                              width="530px"
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {Category === "Pre & Post Construction" && (
                    <>
                      <div className="py-3">
                        <DropDown
                          title="Document Type*"
                          placeholder="None"
                          responseData={responseDataType}
                          labelKey={DocTypeName}
                          valueKey={selectedDocumentType}
                          value={DocType} // ✅ PASS THE ID
                          onChange={onChangeDocumentType}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>

                      <div className="py-3">
                        <DropDown
                          title={
                            Category === "Land Documents"
                              ? "Document Classification *"
                              : "Document Classification"
                          }
                          placeholder="Select"
                          responseData={responseDataClassification}
                          labelKey="label"
                          valueKey="value"
                          value={selectedDocumentClassification}
                          onChange={onChangeDocumentClassification}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>
                      <div className="py-3">
                        <Field
                          label="Box*"
                          type="text"
                          value={box}
                          onChange={onChangeBox}
                          width="530px"
                        />
                      </div>
                      <div className="py-3">
                        <DropDown
                          title="Building Name"
                          placeholder="None"
                          responseData={responseDataBuilding}
                          labelKey={nameBuildingCode}
                          valueKey={buildingId}
                          onChange={onChangeBuilding}
                          value={selectedBuildingId}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>
                      <div className="py-3">
                        <Autocomplete
                          multiple
                          id="multi-select-unique-no"
                          options={responseDataUniqueNo} // Array of options
                          getOptionLabel={(option) => option.unique_survey_no} // Label shown in the dropdown
                          value={uniqueNoId} // This should be an array of selected items
                          onChange={(event, newValue) => {
                            console.log("newValue:", newValue); // Log the new value
                            setSelectedUnique(newValue); // Update state with the new value
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Unique Survey No"
                              placeholder="Select"
                            />
                          )}
                          sx={{ width: 530 }}
                        />
                      </div>

                      <div className="py-3 ">
                        <DatePickerField
                          label="Valid Until"
                          value={PurchaseDate}
                          onChange={onChangePurchaseDate}
                          sx={{ width: "530px" }}
                        />
                      </div>

                      {FileType ===
                        "Other Pre & Post Construction Documents" && (
                        <>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Title*"
                              value={DocumentTitle}
                              onChange={onChangeTitle}
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Description*"
                              value={DocumentDescription}
                              onChange={onChangeDescription}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {Category === "Litigation" && (
                    <>
                      <div className="py-3">
                        <DropDown
                          title="Document Type*"
                          placeholder="None"
                          responseData={responseDataType}
                          labelKey={DocTypeName}
                          valueKey={selectedDocumentType}
                          value={DocType} // ✅ PASS THE ID
                          onChange={onChangeDocumentType}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>

                      <div className="py-3">
                        <DropDown
                          title={
                            Category === "Land Documents"
                              ? "Document Classification *"
                              : "Document Classification"
                          }
                          placeholder="Select"
                          responseData={responseDataClassification}
                          labelKey="label"
                          valueKey="value"
                          value={selectedDocumentClassification}
                          onChange={onChangeDocumentClassification}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>
                      <div className="py-3">
                        <Field
                          label="Box*"
                          type="text"
                          value={box}
                          onChange={onChangeBox}
                          width="530px"
                        />
                      </div>
{Category === "Litigation" && (
<DropDown
  title="CNR Number*"
  placeholder="None"
  responseData={cnrNumbers}
  labelKey="cnr_number"
  valueKey="cnr_number"
  value={selectedCnrNumber}
  onChange={onChangeCnrNumber}
  sx={{ "& .MuiTextField-root": { width: "530px" } }}
/>
)}
                      <div className="py-3">
                        <DropDown
                          title="Os Number*"
                          placeholder="None"
                          responseData={responseDataTypeOs}
                          labelKey={OsNo}
                          valueKey={selectedOs}
                          value={os} // ✅ PASS THE ID
                          onChange={onChangeOS}
                          sx={{ "& .MuiTextField-root": { width: "530px" } }}
                        />
                      </div>
                      {FileType === "Other Litigation Documents" && (
                        <>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Title*"
                              value={DocumentTitle}
                              onChange={onChangeTitle}
                            />
                          </div>
                          <div className="py-3">
                            <Field
                              type="text"
                              label="Document Description*"
                              value={DocumentDescription}
                              onChange={onChangeDescription}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              {activeStep === 2 && (
                <div>
                  {/* Show dropzone only if no files are uploaded */}
                  {uploadedFiles.length === 0 && (
                    <FileUploadDropzone
                      onFileUpload={(files) => {
                        console.log("Uploaded files:", files);
                        setUploadedFiles(files);
                      }}
                    />
                  )}

                  {/* Show uploaded file names once upload is done */}
                  {uploadedFiles.length > 0 && (
                    <div style={{ marginTop: "1rem" }}>
                      <h4>
                        Uploaded File{uploadedFiles.length > 1 ? "s" : ""}:
                      </h4>
                      <ul>
                        {uploadedFiles.map((file, index) => (
                          <li key={index}>{file.name}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </Box>
          </Typography>

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="contained"
              onClick={handlePrevious}
              disabled={activeStep === 0}
            >
              {activeStep === steps.length ? "Cancel" : "Back"}
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                if (activeStep === steps.length - 1) {
                  handleFinishClick(); // 🔁 On last step, submit
                } else {
                  handleNext(); // 🔁 Otherwise, next step
                }
              }}
              disabled={isSubmitting}
            >
              {isSubmitting
                ? "Submitting..."
                : activeStep === steps.length - 1
                  ? "Finish"
                  : "Next"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default UploadModal;
